"use client"

import styles from "./Benefits.module.css"

/**
  @param {string} mainTitle - Ana sayfa başlığı (opsiyonel)
  @param {Array} sections - Bölüm dizisi, her biri başlık, alt başlık, faydalar, paragraflar vb
 */
export default function Benefits({ 
  mainTitle,
  sections = []
}) {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Ana başlık varsa göster */}
        {mainTitle && <h1 className={styles.mainTitle}>{mainTitle}</h1>}
        
        {/* Her bölümü render et */}
        {sections.map((section, index) => (
          <div key={index} className={styles.section}>
            {/* Bölüm başlığı */}
            {section.title && <h2 className={styles.sectionTitle}>{section.title}</h2>}
            
            {/* Alt başlık */}
            {section.subtitle && <p className={styles.subtitle}>{section.subtitle}</p>}
            
            {/* Faydalar listesi */}
            {section.benefits && (
              <ul className={styles.benefitsList}>
                {section.benefits.map((benefit, benefitIndex) => (
                  <li key={benefitIndex} className={styles.benefitItem}>
                    {/* Fayda string ise direkt göster, değilse başlık ve açıklama olarak göster */}
                    {typeof benefit === 'string' ? benefit : (
                      <>
                        <strong>{benefit.title}</strong> {benefit.description}
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )}
            
            {/* Ek paragraflar */}
            {section.paragraphs && section.paragraphs.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex} className={styles.paragraph}>
                {paragraph}
              </p>
            ))}
            
            {/* Sonuç metni */}
            {section.conclusion && <p className={styles.conclusion}>{section.conclusion}</p>}
          </div>
        ))}
      </div>
    </section>
  )
}
